import React from "react";
import {
    useMediaQuery,
    Container,
    Paper,
    Box,
    Typography,
    Divider,
    Button,
    Fade,
    CircularProgress,
} from "@mui/material";
import CancelIcon from '@mui/icons-material/Cancel';
import { useNavigate } from "react-router-dom";

export const AccessDeniedScreen = () => {
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width: 800px)");
    const isMobileSmall = useMediaQuery("(max-width: 530px)");
    return (
        <Container
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
            }}
        >
            <Fade in timeout={750}>
                <Box
                    display="flex"
                    flexDirection="column"
                    justifyContent="center"
                    alignItems="center"
                    height="80vh"
                    textAlign="center"
                    sx={{ color: "#98FF98", padding: 0 }}
                >
                    <Paper
                        sx={{
                            padding: 4,
                            backgroundColor: "#101010",
                            borderRadius: "8px",
                            textShadow: "0px 0px 4px #444",
                        }}
                    >
                        <Typography gutterBottom>
                            <CancelIcon sx={{ opacity: 0.4, fontSize: isMobileSmall ? 80 : 100, color: "#5B5F59", marginBottom: 2 }} />
                        </Typography>
                        <Box sx={{ display: isMobileSmall ? "block" : "none" }}>
                            <Typography variant="body1" gutterBottom sx={{ fontSize: isMobile ? 20 : 18, marginBottom: 1, color: "#d9d9d9" }}>Unable to access <span style={{ color: "#98FF98" }}>j_theceo</span> </Typography>
                            <Typography variant="body1" gutterBottom sx={{ fontSize: isMobile ? 16 : 18, color: "#BBB" }}>
                                Your account requires
                            </Typography>
                            <Typography variant="body1" gutterBottom sx={{ fontSize: isMobile ? 16 : 18, marginTop: -1, marginBottom: 1, color: "#BBB" }}>additional verification</Typography>
                        </Box>
                        <Box sx={{ display: isMobileSmall ? "none" : "block" }}>
                            <Typography variant="body1" gutterBottom sx={{ fontSize: isMobile ? 20 : 20, marginBottom: 2, color: "#d9d9d9" }}>Unable to access <span style={{ color: "#98FF98", fontWeight: "bold" }}>j_theceo</span></Typography>
                            <Typography variant="body1" gutterBottom sx={{ fontSize: isMobile ? 16 : 18, marginBottom: 2, color: "#BBB" }}>
                                Your account requires additional verification</Typography>
                        </Box>
                        <Divider sx={{ opacity: 0.8, my: 4 }} />
                        <Typography variant="body2" sx={{ fontSize: isMobileSmall ? 14 : 14, marginBottom: 2, color: "#bbb" }}>
                            If you believe this is an error, contact <span style={{ color: "#72e8bb" }}>yxn@yiggy.net</span>
                        </Typography>
                        <Button
                            variant="contained"
                            onClick={() => {
                                navigate("/");
                            }}
                            sx={{
                                width: "60%",
                                maxWidth: "180px",
                                marginTop: 2,
                                backgroundColor: "#98FF98",
                                color: "#1a1a1a",
                                fontWeight: "bold",
                                "&:hover": {
                                    backgroundColor: "#629962",
                                },
                            }}
                        >
                            OK
                        </Button>
                    </Paper>
                </Box>
            </Fade>
        </Container>
    );
};

export const LoadingIndicator = () => (
    <Box
        sx={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            height: "100vh",
        }}
    >
        <CircularProgress sx={{ color: "#98FF98" }} />
    </Box>
);
